import { Injectable } from '@angular/core';
import { Theme } from '../models/dto/theme';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  // See: https://medium.com/atom-platform/angular-6-dynamic-themes-without-a-library-c21dfb2cb580
  // https://stackblitz.com/edit/native-theming-form-medium?file=src%2Fapp%2Fcomponents%2Ftheme-picker%2Ftheme-picker.component.ts,src%2Fapp%2Fcomponents%2Ftheme-picker%2Ftheme-picker.component.html
  private themeWrapper = document.querySelector('body');

  setTheme(theme: Theme) {
    if (theme?.themeColour?.length > 0) {
      this.themeWrapper?.style.setProperty('--themeColour', theme.themeColour);
    }
    if (theme?.themeContrastColour?.length > 0) {
      this.themeWrapper?.style.setProperty(
        '--themeContrastColour',
        theme.themeContrastColour
      );
    }
  }
}
